import React from "react";
import PropTypes from "prop-types";
import posed from "react-pose";
import { buttonBar } from "settings";
import { ButtonSet } from "C4";

const BarAnim = posed.div({
  enter: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 50,
  },
});

const ButtonBar = (props) => {
  const { className } = props;
  const { buttons, orientation } = buttonBar;

  return (
    <BarAnim key="BarAnim" className={className}>
      {buttonBar && <ButtonSet buttons={buttons} orientation={orientation} />}
    </BarAnim>
  );
};

export default ButtonBar;

ButtonBar.propTypes = {
  className: PropTypes.string,
};

ButtonBar.defaultProps = {
  className: null,
};
